__turbopack_context__.v({
  "className": "globalfont_affb1ad9-module__bQqK2W__className",
});
